import { RouteItem } from '@aipb/gulliver/frame/model';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'fr-sidebar-route-list',
  templateUrl: './sidebar-route-list.component.html',
  styleUrls: ['./sidebar-route-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, MatListModule, MatButtonModule, RouterLink, RouterLinkActive, TranslocoModule, MatIconModule]
})
export class SidebarRouteListComponent {
  @Input() routes: RouteItem[] = [];
  @Input() expanded: boolean;

  @Output() removeRoute = new EventEmitter<[evt: MouseEvent, route: RouteItem]>();
}
